module.exports = __webpack_public_path__ + "img/ep-fanion.26e38fa6.jpg";